import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { goToTop } from '../../../utils'

import GTMHelper from '../../../Helpers/gtmHelper';

export const SpecsItem = ({ SpecsItemName, SpecsItemModel, SpecsItemEditUrl, useHTML, isPackage, ...props }) => {
    const { t, i18n } = useTranslation(['summary', 'general']);
    const navigate = useNavigate();
    let SpecsItemModelStriped
    if(!useHTML){
        SpecsItemModelStriped = SpecsItemModel.replace(/(<([^>]+)>)/gi, "");
    }else{
        SpecsItemModelStriped = SpecsItemModel;
    }
    
    const gtmHelper = new GTMHelper();

    const handleOnClick = (e) => {
        goToTop();
        navigate(SpecsItemEditUrl);
        gtmHelper.setGTM({'action':'Edit Specs','value': e.target.innerHTML}, true, false);
    }

    return (
        <div className={isPackage ? useHTML ? "mz-specs__item spec-packages spec-packages_wide"  : 'mz-specs__item spec-packages' : "mz-specs__item"}>
            <p className="mz-specs__category" onClick={handleOnClick}>
                <a className="mz-link">{ SpecsItemName }</a>
            </p>
            <div className="mz-specs__right">
                <p className="mz-specs__name">{ ReactHtmlParser(SpecsItemModelStriped) }</p>
            </div>
        </div>
    )
};

SpecsItem.propTypes = {
    SpecsItemName:  PropTypes.string,
    SpecsItemModel: PropTypes.string,
    SpecsItemEditUrl: PropTypes.string,
}

SpecsItem.defaultProps = {
    SpecsItemName: 'SPECS NAME',
    SpecsItemModel: '',
    SpecsItemEditUrl: '',
}

export default SpecsItem;